((app) => {
    app.component("searchBar", {
        templateUrl: "/App/States/Root/Navbar/SearchBar/search.bar.html",
        controller: _searchBarCtrl,
        bindings: {
            ngModel: "="
        }
    });

    _searchBarCtrl.$inject = ["$rootScope", "searchService", "$state", "accessTokenService"];
    function _searchBarCtrl($rootScope, searchService, $state, accessTokenService) {
        let $ctrl = this;

        if (accessTokenService.hasAdminAccess()) {
            $ctrl.isAdmin = true;
        }

        searchService.register(_observerCallback);

        function _observerCallback() {
            $ctrl.criteria = searchService.getTerm();
        }

        $ctrl.search = ($event, criteria) => {
            if($event.keyCode === 13) {
                if (searchService.getTerm() !== criteria) {
                    searchService.set(criteria);
                    searchService.setFilters(null, null, null);
                    $rootScope.$broadcast("searching");
                    $state.go("Root.Policies.List");
                }
            }
        };
     }
})(window.app);
